
export interface EdgeResult<T> {
    totalCount: number;
    list: T[];
}
